import { risapi, getAxiosConfig, getAPIFullUrl } from './risapi';

/**
 * Fetches a paginated list of all member payments (credits).
 * @param {object} filters - Page, per_page, search_term
 * @param {function} callback - The function to call with the response.
 */
export const getPayments = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/payments', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};